import React, { useEffect, useState } from 'react';
import HandoverItemsModel from './models/HandoverItemsModel';

function DeleteHandoverItems(props) {
    const [getDeleteHandoverItems, setDeleteHandoverItems] = useState(new HandoverItemsModel() || []);

    useEffect(() => {
        setDeleteHandoverItems(props.HandoverItemsData);
    }, [props.HandoverItemsData]);

    return (
        <>
            <div className="text-left px-2 pb-0">
                <p>
                    <h6>Following handover item will be deleted and could not be recovered!!</h6>
                    <ul>
                        <li><b>Handover Item Type :</b> {getDeleteHandoverItems.HandoverItemType}</li>
                        <li><b>Handover Item Title :</b> {getDeleteHandoverItems.HandoverItemTitle}</li>
                        <li><b>Description : </b>{getDeleteHandoverItems.Description}</li>
                    </ul>
                </p>
            </div>
            <div id="DeleteHandoverItemsDetails" hidden>{JSON.stringify(getDeleteHandoverItems)}</div>
        </>
    );
}

export default DeleteHandoverItems;
